export const APP_STYLES = ['default', 'ipt', 'pp'] as const;

export type AppStyle = (typeof APP_STYLES)[number];
